export default __webpack_public_path__ + "assets/front/scss/error.e75f46eea73d550285c5f5c40e14f47c.css";